
/* injects from baggage-loader */

/*
 * Configure routes, ect.
 * todo: На данный момент разработка всегда ведется в режиме production,
 * todo: либо настроить разработку в development режиме, либо удалить все условия связанные с ENV === 'development'
 */

angular.module("siter.io").config([
  "$locationProvider", "$stateProvider", "$urlRouterProvider", "$provide", "growlProvider", "$httpProvider", "RestangularProvider", "NotificationProvider", "$cookiesProvider", "$sceDelegateProvider", "ivhTreeviewOptionsProvider", "$translateProvider",
  ($locationProvider, $stateProvider, $urlRouterProvider, $provide, growlProvider, $httpProvider, RestangularProvider, NotificationProvider, $cookiesProvider, $sceDelegateProvider, ivhTreeviewOptionsProvider, $translateProvider) => {

    // Set normal url
    $locationProvider.html5Mode(false);

    // Tree library config
    ivhTreeviewOptionsProvider.set({
      useCheckboxes: true,
      defaultSelectedState: false,
      twistieExpandedTpl: '<img src="/constructor/editor/assets/images/openedfolder-icon.png" style="opacity:0.7" />',
      twistieCollapsedTpl: '<img src="/constructor/editor/assets/images/folder-icon.png" />',
      twistieLeafTpl: '',
      labelAttribute: "label"
    });

    // Log function, error function
    window.log = (...args) => {
      console.log.apply(console, args);
    };
    window.err = (message) => {
      throw new Error(message);
    };

    // Notifications
    NotificationProvider.setOptions({
      delay: 5000,
      startTop: 20,
      startRight: 10,
      verticalSpacing: 20,
      horizontalSpacing: 20,
      positionX: 'left',
      positionY: 'top'
    });

    const devHosts = ["lvh.me:4000", "localhost:8080", "localhost:4000"];

    // set env
    if (document.location.host in devHosts) {
      window.ENV = "development";
    } else {
      window.ENV = "production";
    }

    // Restangular configs
    if (window.ENV === "development") {
      host = "/v1";
    } else {
      host = window.justclick.apiURL;
    }

    // set cookies config
    $cookiesProvider.defaults.path = document.location.href;
    $cookiesProvider.defaults.domain = document.location.host;

    RestangularProvider.setBaseUrl(host);

    if (ENV === "development") {
      $translateProvider.useLoader('TranslationLoader', {
        prefix: '/assets/languages/locale-',
        suffix: '.json'
      });
    } else {
      $translateProvider.useLoader('TranslationLoader', {
        prefix: '/constructor/editor/assets/languages/locale-',
        suffix: '.json'
      });
    }

    $translateProvider.preferredLanguage(window.justclick.locale);
    $translateProvider.registerAvailableLanguageKeys(['ru', 'en', 'es'], { 'ru_*': 'ru', 'en_*': 'en', 'es_*': 'es' });
    $translateProvider.fallbackLanguage('en');
    $translateProvider.useSanitizeValueStrategy('escapeParameters');

    $sceDelegateProvider.resourceUrlWhitelist(['**']);

    // Errors interceptor
    $httpProvider.interceptors.push("errorsInterceptor");

    // Routes
    $stateProvider
      .state('404', {
        url: '/404',
        templateUrl: './common/templates/404.jade',
        auth: true
      })
      // New site pages
      .state('root', {
        url: '/site',
        templateUrl: './site/site.jade',
        abstract: true,
        auth: true
      })
      .state('root.site', {
        url: '/:siteId',
        templateUrl: './site/site.jade',
        controller: 'Sites',
        abstract: true,
        auth: true
      })
      .state('admin', {
        url: '/admin',
        templateUrl: './common/templates/layout.jade',
        abstract: true,
        auth: true
      })
      // Dashboard
      .state('admin.dashboard', {
        url: '/dashboard',
        controller: "Dashboard",
        templateUrl: './dashboard/dashboard.jade'
      })
      .state('admin.dashboard.templates', {
        url: '/templates',
        templateUrl: './dashboard/list.jade'
      })
      .state('admin.dashboard.sections', {
        url: '/sections',
        templateUrl: './dashboard/list2.jade'
      })
      .state('admin.dashboard.images', {
        url: '/images',
        templateUrl: './dashboard/list3.jade'
      })
      .state('admin.dashboard.emails', {
        url: '/emails',
        templateUrl: './dashboard/list4.jade'
      })
      .state('admin.dashboard.emailSections', {
        url: '/email_sections',
        templateUrl: './dashboard/list5.jade',
        title: "Секции для писем"
      })
      .state('admin.dashboard.webForms', {
        url: '/web_forms',
        controller: "DashboardWebForms",
        templateUrl: './dashboard/webFormsList.jade',
        title: "Веб-формы"
      })
      .state('admin.dashboard.lessons', {
        url: '/lms_pages',
        controller: "DashboardLessons",
        templateUrl: './dashboard/lessonsList.jade',
        title: "Lms"
      })
      .state('admin.dashboard.lessonSections', {
        url: '/lms_page_sections',
        controller: "DashboardLessonSections",
        templateUrl: './dashboard/lessonSectionsList.jade',
        title: "Секции Lms"
      })
      // site
      .state("site", {
        url: "/sites/:siteId",
        controller: "Sites",
        templateUrl: './editor/editorLayout.jade',
        auth: true
      })
      .state("site.page", {
        url: "/:pageId",
        templateUrl: "./editor/pageLayout.jade",
        abstract: true,
        auth: true
      })
      .state("site.page.editor", {
        url: "/editor",
        controller: "EditorCtrl",
        templateUrl: "./editor/editor.jade",
        auth: true
      })
      .state("site.page.mixer", {
        url: "/mixer",
        controller: "EditorCtrl",
        templateUrl: "./editor/editor.jade",
        auth: true,
        title: "Микшер"
      })
      .state("lesson.page.mixer", {
        url: "/mixer",
        controller: "EditorLessonCtrl",
        templateUrl: "./editor/editorLesson.jade",
        auth: true,
        title: "Микшер"
      })
      // editor
      .state("editor", {
        url: '/editor',
        templateUrl: './editor/editorLayout.jade',
        abstract: true,
        auth: true
      })
      .state("editor.section", {
        url: "/:sectionId",
        controller: "EditorCtrl",
        templateUrl: "./editor/editor.jade",
        auth: true
      })
      // Editor email
      .state("email", {
        url: "/emails/:emailId",
        controller: "Emails",
        templateUrl: './editor/editorLayout.jade',
        auth: true
      })
      .state("email.page", {
        url: "/:pageId",
        templateUrl: "./editor/pageLayout.jade",
        abstract: true,
        auth: true,
        title: "Страница"
      })
      .state("email.page.editor", {
        url: "/editor",
        controller: "EditorEmailCtrl",
        templateUrl: "./editor/editorEmail.jade",
        auth: true,
        title: "Редактор"
      })
      // Editor form
      .state("form", {
        url: "/web_forms/:formId",
        controller: "Forms",
        templateUrl: './editor/editorLayout.jade',
        auth: true
      })
      .state("form.page", {
        url: "/:pageId",
        templateUrl: "./editor/pageLayout.jade",
        auth: true,
        abstract: true,
        title: "Страница"
      })
      .state("form.page.editor", {
        url: "/editor",
        controller: "EditorFormCtrl",
        templateUrl: "./editor/editorForm.jade",
        auth: true,
        title: "Редактор"
      })
      // Editor lessons
      .state("lesson", {
        url: "/lms_pages/:lessonId",
        controller: "Lessons",
        templateUrl: './editor/editorLayout.jade',
        auth: true
      })
      .state("lesson.page", {
        url: "/:pageId",
        templateUrl: "./editor/pageLayout.jade",
        auth: true,
        abstract: true,
        title: "Страница"
      })
      .state("lesson.page.editor", {
        url: "/editor",
        controller: "EditorLessonCtrl",
        templateUrl: "./editor/editorLesson.jade",
        auth: true,
        title: "Редактор"
      });

    $urlRouterProvider.otherwise('/');

    // notification timeout
    growlProvider.globalTimeToLive(5000);
  }
]);



// WEBPACK FOOTER //
// ./src/app/app-main/siter.config.js